import { useEffect, useState } from "react";
import config  from "../config";

import getData from "../common/getData";
import hasProps from "../common/hasProps";
import { useKeycloak } from "@react-keycloak/web";

const ApiURL = `${config.app.apiBaseUrl}chatbots/v1/Chats/Search`;

function useGetChatsOnSearch(ChatDataSearchFields){
  const [chats, setChats] = useState([]);
  const { keycloak } = useKeycloak();

  useEffect(
    function() {
      async function init() {
        if (!keycloak?.token) return;
        if (!hasProps(ChatDataSearchFields)){
          setChats([]);
          return chats;
        };

        let chatsList = await getData(keycloak.token, createParaURL(ApiURL, ChatDataSearchFields), "json", false)
        if (chatsList) {
          setChats(chatsList);
        }
      }
      init();
    },
    // eslint-disable-next-line
    [JSON.stringify(ChatDataSearchFields)]
  );
  return {chats};
}

function createParaURL(url, {UserId, CurrentPage, AmountPerPage}){
  return url + `?UserId=${encodeURIComponent(UserId)}&CurrentPage=${encodeURIComponent(CurrentPage)}&AmountPerPage=${encodeURIComponent(AmountPerPage)}`
}

export default useGetChatsOnSearch;